import {isEmpty as _isEmpty} from "lodash";
import * as React from "react";
import { FitnessPrescriptionItemRequest, PrescriptionItemGuideline } from "@curefit/gmf-common";
import { AppConstants, ORION_IMG_URL } from "../../../utils/AppConstants";
import AppUtils from "../../../utils/AppUtils";

export interface FitnessPlanPDFProps {
    id: string;
    planItem: any;
    iconImage: string;
    header: string;
}

const FitnessPlanPDFTemplate: React.StatelessComponent<FitnessPlanPDFProps> = (props: FitnessPlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemToIterate = planItem[id];
    let guidelineItems = itemToIterate.filter((item: string | object) => typeof item === "string");
    const activities = itemToIterate.filter((item: string | object) => typeof item === "object");
    return (
        <div id={id} className="prescription-grid-row external-row">
            <div className="prescription-card-content">
                <div className="prescription-sec-heading brandon-bold">{props.header}</div>
                <div id={`${id}-subsection`} className="prescription-description">

                    {
                        !_isEmpty(guidelineItems) && guidelineItems.map((item: string, index: number) => {
                            return (
                                <li className={"guidelines-section"}>
                                    <div className={"guideline-item"} key={`guideline-${index}`}>{item}</div>
                                </li>)
                        })
                    }
                    {
                        !_isEmpty(activities) && activities.map((fitnessItem: any, index: number) => {
                            return (<li key={index}>
                                <div className={"activity-name"}><span className="prescription-subheading">{fitnessItem.activity.displayValue}&nbsp;</span></div>
                                <div className={"activity-duration"}>
                                    {
                                        AppUtils.isDefined(fitnessItem.duration) && fitnessItem.duration !== "" &&
                                        <span className="prescription-description">{((fitnessItem.duration)).toFixed(2)} minutes</span>
                                    }
                                </div>
                                <div className={"activity-frequency"}>
                                    {
                                        !_isEmpty(fitnessItem.frequency) && AppUtils.isDefined(fitnessItem.frequency.unit) && AppUtils.isDefined(fitnessItem.frequency.count) &&
                                        <span className="prescription-description">
                                            {`${fitnessItem.frequency.count} times / ${AppConstants.FrequencyUnit[fitnessItem.frequency.unit]}`}
                                        </span>
                                    }
                                </div>
                                <div className={"activity-comment"}>
                                    {
                                        !_isEmpty(fitnessItem.advice) &&
                                        <span className="prescription-description">{`${fitnessItem.advice}`}</span>
                                    }
                                </div>
                            </li>)
                        })
                    }
                    {/*</div>*/}
                </div>
                {
                    itemToIterate && itemToIterate.length > 2 &&
                    <div className={"fitness-plan-image-container"}>
                        <img src={ORION_IMG_URL + props.iconImage} className={"fitness-plan-image"} />
                    </div>
                }
            </div>
        </div>
    )
}

export default FitnessPlanPDFTemplate;